import React from 'react';

const colorPairs = [
  { bg: 'bg-blue-50', text: 'text-blue-600' },
  { bg: 'bg-green-50', text: 'text-green-600' },
  { bg: 'bg-purple-50', text: 'text-purple-600' },
  { bg: 'bg-orange-50', text: 'text-orange-600' },
  { bg: 'bg-pink-50', text: 'text-pink-600' },
  { bg: 'bg-indigo-50', text: 'text-indigo-600' }
];

const getInitialsColor = (name) => {
  if (!name) return colorPairs[0];
  let sum = 0;
  for (let i = 0; i < name.length; i++) sum += name.charCodeAt(i);
  return colorPairs[sum % colorPairs.length];
};

const getInitials = (name) => {
  if (!name) return 'U';
  return name
    .split(' ')
    .filter(word => word.length > 0)
    .map(word => word[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
};

const UserAvatar = ({ name, imageUrl, size = 80, className = "" }) => {
  const [imageFailed, setImageFailed] = React.useState(false);

  React.useEffect(() => {
    setImageFailed(false);
  }, [imageUrl]);

  const isUrlValid = imageUrl && imageUrl.trim() !== '' && imageUrl !== 'null' && imageUrl !== 'undefined' && !imageFailed;

  if (isUrlValid) {
    return (
      <div 
        className={`rounded-full overflow-hidden flex items-center justify-center shrink-0 bg-slate-50 border border-slate-200 ${className}`}
        style={{ width: size, height: size }}
      >
        <img
          src={imageUrl}
          alt={name || 'User'}
          className="w-full h-full object-cover"
          onError={() => setImageFailed(true)}
        />
      </div>
    );
  }

  const colorPair = getInitialsColor(name);

  return (
    <div 
      className={`rounded-full flex items-center justify-center shrink-0 font-bold border border-white shadow-sm ${colorPair.bg} ${colorPair.text} ${className}`}
      style={{ 
        width: size, 
        height: size, 
        fontSize: size * 0.35
      }}
    >
      {getInitials(name)}
    </div>
  );
};

export default UserAvatar;
